import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Kõik %s

  <span style="color:#85c1dc;">**FI:**</span>
  Kaikki %s

  <span style="color:#85c1dc;">**RU:**</span>
  Все %
*/
/* @__NO_SIDE_EFFECTS__ */
const m1841 = msg(
  mf`Kõik %s`,
  mf`Kaikki %s`,
  mf`Все %`,
)

export { m1841 as 'w.module.categories_search.view_all' }